import { HttpClient } from '@angular/common/http';
import { UxService } from '~/app/core/services';
import { GenericApi } from '~/app/open-age/core/services';
import { RoleService } from '../../core/services';
import { EncryptionDecryptionService } from '~/app/services/encryptDecrypt/encryption-decryption.service';

export class DriveApiBase<TModel> extends GenericApi<TModel> {
  constructor(
    collection: string,
    http: HttpClient,
    auth: RoleService,
    encryptDecryptService: EncryptionDecryptionService,
    uxService: UxService
  ) {
    super(http, 'drive', { collection, auth, errorHandler: uxService });
  }
}
